export const productsData = {
  ups: [
    {
      name: 'BBE MARS',
      category: 'SAI Online Monofásico',
      description: 'UPS online doble conversión para aplicaciones críticas monofásicas.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/803d390bee5148ac1e7373d7a1062ba7.png'
    },
    {
      name: 'BBE MARS II',
      category: 'SAI Online Monofásico',
      description: 'Evolución de la serie MARS con mayor eficiencia y control digital avanzado.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/f058e15b820f470c7d913e6a3e0ffc7f.png'
    },
    {
      name: 'BBE URANUS',
      category: 'SAI Online Trifásico',
      description: 'UPS trifásico industrial para infraestructura crítica y centros de datos.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/952178be67586dc04eecde1c26299cce.png'
    },
    {
      name: 'BBE SATURN',
      category: 'SAI Online Trifásico Modular',
      description: 'Sistema UPS modular escalable para alta disponibilidad.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/1defebde1d8dfdcd22020a31cf766de2.png'
    }
  ],
  industrial: [
    {
      name: 'NEPTUNE',
      category: 'Rectificador Conmutado Compacto',
      description: 'Sistema rectificador compacto de alta eficiencia para telecom e industria.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/c65c74bff28ed02fb5df3688db1e06b4.png'
    },
    {
      name: 'BBE JUPITER',
      category: 'Rectificador Modular',
      description: 'Plataforma modular escalable para sistemas DC críticos.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/911d761bad8f9993973e3418e9d6d9ab.png'
    },
    {
      name: 'BBE VENUS',
      category: 'Inversor Industrial',
      description: 'Inversor industrial robusto para aplicaciones críticas.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/4d3bcff5acd19758c29c3de9dae11c16.png'
    }
  ],
  storage: [
    {
      name: 'BBE NCD',
      category: 'Batería Níquel Cadmio',
      description: 'Solución Ni-Cd para aplicaciones industriales exigentes.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/171f621e1e961390a0edf8cbfa088101.png'
    },
    {
      name: 'BBE PB',
      category: 'Batería Plomo VRLA',
      description: 'Tecnología VRLA para respaldo energético confiable.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/b96286cbebd39b2df309e9d7e1e8e3f9.png'
    },
    {
      name: 'BBE LI',
      category: 'Batería Litio',
      description: 'Sistema LiFePO4 de alta densidad energética y larga vida útil.',
      image: 'https://static.readdy.ai/image/31babc308b349a6cc45afd813037d21e/d7441b2e5ae4ec390bb1d9b0dd6ffe30.png'
    }
  ]
};
